const st_a = {
	fill: "#222161",
	stroke: "#222161",
	strokeMiterlimit: 10,
	strokeWidth: 2
};

const st_b = {
	fill: "none",
	stroke: "#222161",
	strokeMiterlimit: 10,
	strokeWidth: 2
};

const explanation_svg = (
	<svg height={20} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52.49 55.38">
		<path
			style={st_b}
			d="M25.1,1.39H5.35C3.17,1.39,1.4,3.45,1.4,6v9.59c0,2.53,1.77,4.58,4,4.58H17.52l4.17,3.28,3.46-3.28c2.16,0,3.91-2.07,3.91-4.58V6C29.06,3.45,27.29,1.39,25.1,1.39Z"
		/>
		<path
			style={st_b}
			d="M6,6.32a23,23,0,0,0,6.31.78c4,0,3.34-1,6.37-1A41.93,41.93,0,0,1,25,6.57"
		/>
		<path
			style={st_b}
			d="M6,10.34a23.24,23.24,0,0,0,6.31.77c4,0,3.34-1,6.37-1a42.73,42.73,0,0,1,6.32.53"
		/>
		<path
			style={st_b}
			d="M6,14.35a22.75,22.75,0,0,0,6.31.77c4,0,3.34-1,6.37-1A41.93,41.93,0,0,1,25,14.6"
		/>
		<circle style={st_a} cx="38.16" cy="17.13" r="6.6" />
		<path
			style={st_a}
			d="M42.52,54H34.75a6.11,6.11,0,0,1-6.11-6.11l-2-16.61a6.11,6.11,0,0,1,6.11-6.11H44.52a6.12,6.12,0,0,1,6.12,6.11l-2,16.61A6.12,6.12,0,0,1,42.52,54Z"
		/>
		<path
			style={st_a}
			d="M27.45,34.94s-11.16.94-14.11,0-8.81-9.07-8.81-9.07-2.08-3.2.74-2.44,7,6.67,10,7.21,12.22-.41,12.22-.41"
		/>
	</svg>
);

export default explanation_svg;
